"use client";

import React from "react";
import { EmailVerificationProvider } from "./EmailVerificationContext";

export default function InactiveAccountGuard({ children }: { children: React.ReactNode }) {
  return <EmailVerificationProvider>{children}</EmailVerificationProvider>;
}
